// Boshliq qarori (2026-09-13, tog'a #1870/#1885): tovar/jadval ustunlarini kim ko'rishini BOSH ADMIN belgilaydi —
// «Роли и права → ustunlar» (mainRoleColumns; hiddenFeatures ichida "col:<key>", eski whitelist bilan moslik).
// Bu yordamchi TableExtended'dan tashqaridagi oddiy antd Table'lar uchun.
import { MODULE_COLUMNS_DEFINITION, hiddenColumnKeys } from "../data/moduleColumns"

export const roleAllowsColumn = (user: any, moduleCode: string, key: string): boolean => {
  try {
    const perms: any[] = user?.permissions || []
    const p = perms.find((m: any) => m?.moduleCode && String(m.moduleCode).toLowerCase() === moduleCode.toLowerCase())
    if (!p) return true
    return !hiddenColumnKeys(p, MODULE_COLUMNS_DEFINITION[moduleCode] || []).has(key)
  } catch {
    return true
  }
}

/** Boshliq «Menejer huquqlari» (2026-09-14): modul ichidagi FUNKSIYA (export/import/summary/filter/invoice/setPrices/…) rol ∪ menejer
 *  sozlamasida yashirilgan bo'lsa — sahifadagi tugma umuman chizilmaydi (MyPermissions.hiddenFeatures). */
export const roleAllowsFeature = (user: any, moduleCode: string, key: string): boolean => {
  try {
    const perms: any[] = user?.permissions || []
    const p = perms.find((m: any) => m?.moduleCode && String(m.moduleCode).toLowerCase() === moduleCode.toLowerCase())
    const feats: string[] = Array.isArray(p?.hiddenFeatures) ? p.hiddenFeatures : []
    return !feats.includes(key)
  } catch {
    return true
  }
}
